export default __webpack_public_path__ + "static/media/glass_a.19ef7003.svg";